/**
 * Edits made in place and not yet saved (F96): one per thing edited, named by a key the view
 * chooses, in the order they were first made. Editing the same thing again replaces its edit.
 * An edit that can't be proposed as it stands keeps its problem, so it blocks the save
 * instead of an older version of it being saved.
 */
export interface StagedEdit<Edit> {
  readonly key: string;
  readonly edit: Edit;
  /** Why the edit can't be saved as it stands, in the view's terms; `null` when it can. */
  readonly problem: string | null;
}

export type StagedEdits<Edit> = readonly StagedEdit<Edit>[];

export function withStaged<Edit>(edits: StagedEdits<Edit>, staged: StagedEdit<Edit>): StagedEdits<Edit> {
  return edits.some((kept) => kept.key === staged.key) ? edits.map((kept) => (kept.key === staged.key ? staged : kept)) : [...edits, staged];
}

export function withoutStaged<Edit>(edits: StagedEdits<Edit>, key: string): StagedEdits<Edit> {
  return edits.filter((staged) => staged.key !== key);
}

export function stagedEdit<Edit>(edits: StagedEdits<Edit>, key: string): StagedEdit<Edit> | undefined {
  return edits.find((staged) => staged.key === key);
}
